// extracted by mini-css-extract-plugin
module.exports = {"TrendIcon":"TrendIcon_TrendIcon__2gA-H","TrendIconUp":"TrendIcon_TrendIconUp__1fagk","TrendIconDown":"TrendIcon_TrendIconDown__178uQ"};